import {
    BlockMapBuilder, Modifier, convertFromHTML,
} from 'draft-js';
import { FOUR_SPACES } from './CONSTANTS';
import contentToEditorState from './contentToEditorState';
import cleanHTML from './cleanHTML';

const TETTRA_PAGE_REGEX = /tettra.co\/teams\/(\w+)\/pages\//;

const isGoogleDocsPaste = html => /docs-internal-guid-/.test(html);

const handleGoogleDocsPaste = (html, editorState) => {
    const contentState = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const htmlFragement = convertFromHTML(cleanHTML(html));
    const blockMap = BlockMapBuilder.createFromArray(htmlFragement.contentBlocks);
    return Modifier.replaceWithFragment(
        contentState,
        selection,
        blockMap,
    );
};

const isTettraLink = (text) => {
    const textIsLink = text.split(' ').length === 1;
    return textIsLink && TETTRA_PAGE_REGEX.test(text);
};

const getPageSlugFromText = (text) => {
    const urlParts = text.trim().split(TETTRA_PAGE_REGEX);
    if (urlParts.length === 3 && urlParts[2]) {
        return urlParts[2];
    }
    return null;
};

const getTettraPage = (text) => {
    const slug = getPageSlugFromText(text);
    const pages = window.pages || [];
    return slug && pages.find(p => (slug === getPageSlugFromText(p.url)));
};

const pasteInsideList = (contentState, selection, text = '', type) => {
    const pastedContentState = contentToEditorState({
        blocks: text.split('\n')
            .filter(item => item.trim().length > 0)
            .map(mapText => ({
                type,
                text: mapText,
            })),
        entityMap: {},
    }).getCurrentContent();

    return Modifier.replaceWithFragment(
        contentState,
        selection,
        pastedContentState.getBlockMap(),
    );
};

const removeTabsFromText = text => text.replace(/\t/g, FOUR_SPACES);

export {
    pasteInsideList, isGoogleDocsPaste, handleGoogleDocsPaste, isTettraLink, getTettraPage, removeTabsFromText,
};
